module.exports = __webpack_public_path__ + "img/booking_retail.c0e611cc.svg";